import React, { useContext } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { AppContext } from "../../AppContextProvider";
import MenuItemTypesLegend from "../menus/MenuItemTypesLegend";
import { CALENDAR_URL } from "../../MainAppPanel";
import { useNavigate } from "react-router-dom";
import OrderedMealsTable from "./OrderedMealsTable";
import { DateTimeUtils } from "../../DateTimeUtils";
import { Role } from "../../models/User";

const OrderedMealsPage: React.FC = () => {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();

  const handleOrder = () => {
    navigate(CALENDAR_URL);
  };

  return (
    <Box
      sx={{ pt: 2, pb: 2, display: "flex", flexDirection: "column", gap: 1 }}
    >
      <Stack
        direction="row"
        gap={1}
        justifyContent="space-between"
        alignItems="center"
        pl={2}
        pr={2}
      >
        <Box>
          <Typography fontWeight="bold" mb={1}>
            Upcoming Meals For My Family
          </Typography>
          <MenuItemTypesLegend />
        </Box>
        {user.role !== Role.ADMIN ? (
          <Stack direction="row" gap={2} alignItems="center">
            {user.availableCredits > 0 && (
              <Typography variant="body2" color="text.secondary">
                Available Credits: ${user.availableCredits.toFixed(2)}
              </Typography>
            )}
            <Button
              size="small"
              onClick={handleOrder}
              color="primary"
              variant="contained"
            >
              Order Meals
            </Button>
          </Stack>
        ) : (
          <></>
        )}
      </Stack>

      <Box sx={{ pl: 2, pr: 2, overflowX: "auto" }}>
        <Box minWidth={"600px"}>
          <OrderedMealsTable
            user={user}
            startDate={DateTimeUtils.toString(DateTimeUtils.getCurrentDate())}
            highlightMealsNotOrderedByMe={true}
            allowPurchaserCancel={true}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OrderedMealsPage;
